import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './ArrowButton.less';

const ArrowButton = ({
  component: Component = 'a',
  className,
  direction,
  children,
  smaller = false,
  ...props
}) => {
  const classes = cx(
    'arrow-button',
    { 'arrow-button--smaller': smaller },
    `arrow-button--${direction}`,
    className
  );
  const isDisabled = className?.includes('slick-disabled');

  return (
    <Component className={classes} {...props} disabled={isDisabled}>
      {children}
    </Component>
  );
};

ArrowButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  component: PropTypes.oneOf(['button', 'a', 'div']),
  direction: PropTypes.oneOf(['left', 'right', 'down', 'up']).isRequired,
  smaller: PropTypes.bool,
};

export default ArrowButton;
